// src/components/DateRangeFilter.js
import React, { useState } from 'react';

function DateRangeFilter({ onApply, onClear, label = 'Date Range' }) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  
  const handleApply = () => {
    if (startDate && endDate) {
      onApply({ startDate, endDate });
      setIsOpen(false);
    } else {
      alert('Please select both start and end dates');
    }
  };
  
  const handleClear = () => {
    setStartDate('');
    setEndDate('');
    if (onClear) onClear();
    setIsOpen(false);
  };
  
  const getDatePreset = (days) => {
    const today = new Date();
    const end = new Date();
    const start = new Date();
    start.setDate(today.getDate() - days);
    
    const formatDate = (date) => {
      return date.toISOString().split('T')[0];
    };
    
    setStartDate(formatDate(start));
    setEndDate(formatDate(end));
    onApply({ startDate: formatDate(start), endDate: formatDate(end) });
    setIsOpen(false);
  };
  
  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '8px 16px',
          backgroundColor: 'white',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
        }}
      >
        <span>📅</span> {label}
        {startDate && endDate && (
          <span style={{ fontSize: '12px', color: '#64748b' }}>
            ({startDate} to {endDate})
          </span>
        )}
      </button>
      
      {isOpen && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 8px)',
          right: 0,
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          zIndex: 100,
          minWidth: '320px',
          border: '1px solid #e2e8f0',
        }}>
          <div style={{ marginBottom: '12px' }}>
            <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px' }}>Quick Select</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <button onClick={() => getDatePreset(7)} style={presetButtonStyle}>Last 7 Days</button>
              <button onClick={() => getDatePreset(30)} style={presetButtonStyle}>Last 30 Days</button>
              <button onClick={() => getDatePreset(90)} style={presetButtonStyle}>Last 90 Days</button>
              <button onClick={() => getDatePreset(365)} style={presetButtonStyle}>Last Year</button>
            </div>
          </div>
          
          <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '12px' }}>
            <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px' }}>Custom Range</div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '12px', color: '#64748b' }}>Start</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={{ fontSize: '12px', color: '#64748b' }}>End</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={inputStyle}
                />
              </div>
            </div>
          </div>
          
          <div style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'flex-end' }}>
            <button
              onClick={handleClear}
              style={{
                padding: '6px 16px',
                backgroundColor: '#e2e8f0',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
              }}
            >
              Clear
            </button>
            <button
              onClick={handleApply}
              style={{
                padding: '6px 16px',
                backgroundColor: '#f97316',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const presetButtonStyle = {
  padding: '4px 12px',
  backgroundColor: '#f1f5f9',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
  fontSize: '12px',
  color: '#475569',
};

const inputStyle = {
  padding: '6px 10px',
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
  fontSize: '13px',
  width: '100%',
};

export default DateRangeFilter;